import ComponentManager from '@/Management/ComponentManager';
import ControlFactory from '@/Factories/ControlFactory';
import SimpleLabelBuilder from '@/Builder/SimpleLabelBuilder';
import * as DateHelper from '@/Utility/DateHelper'
import DateTimeLabelFactory from '@/Factories/ControlFactories/DateTimeLabelFactory';
import DetailViewContext from '@/ViewModels/Contexts/DetailViewContext';
import ResourceManager from '@/Management/ResourceManager';
import Factory from '@/Factories/Factory';
import MultilineTextBoxPopUpLinkType from '@/Components/Links/MultilineTextBoxPopUpLink/MultilineTextBoxPopUpLink';
import MultilineTextBoxPopUpLinkViewModelType from '@/Components/Links/MultilineTextBoxPopUpLink/MultilineTextBoxPopUpLinkViewModel';

export default class InlineLabelFactory extends ControlFactory {
    private MultilineTextBoxPopUpLink = ComponentManager.getControl<typeof MultilineTextBoxPopUpLinkType>('MultilineTextBoxPopUpLink');
    private MultilineTextBoxPopUpLinkViewModel = ComponentManager.getViewModel<typeof MultilineTextBoxPopUpLinkViewModelType>('MultilineTextBoxPopUpLinkViewModel');
    private jQueryControl: JQuery;

    /**
    * @override
    */
    public context: DetailViewContext;


    constructor(private params: any) {
        super(params);
    }

    /**
     * @override
     */
    public getControl(): JQuery {
        if (this.jQueryControl)
            return this.jQueryControl;

        const value = this.context.genericObject.getObservable<string>(this.detailViewItem.name);
        this.jQueryControl = this.createControl(value);
        this.jQueryControl.addClass('c-inlinelabel');

        if (this.params.detailViewContext.isSummaryViewMode())
            return this.jQueryControl;

        this.defineSubscription(value, (newValue: string) => {
            this.jQueryControl.text(this.resolveValue(newValue));
        });

        return this.jQueryControl;
    }

    private createControl(value: KnockoutObservable<string>): JQuery<HTMLElement> {
        if (DateHelper.isDotNetDatetimeString(value()))
            return new DateTimeLabelFactory(this.params).getControl();

        const resolvedValue = this.resolveValue(value);
        const label = new SimpleLabelBuilder()
            .withCaption(resolvedValue)
            .buildAndGetElement();

        if (resolvedValue && this.isMultiLine())
            return this.wrapWithMultilineTextBoxPopUpLink(resolvedValue, label);

        return $(label);
    }

    private isMultiLine(): boolean {
        const originalParameter = Factory.parseUIGeneratorQuery(this.detailViewItem.uiGenerator);
        return !!originalParameter.parameters?.multiline;
    }

    private wrapWithMultilineTextBoxPopUpLink(value: string, currentControl: HTMLElement): JQuery<HTMLElement> {
        const vm = new this.MultilineTextBoxPopUpLinkViewModel({
            name: this.detailViewItem.name,
            ergName: this.detailViewItem.ergName,
            value: value,
            isEditingEnabled: false,
            parentLocator: this.locator
        });

        const link = new this.MultilineTextBoxPopUpLink(vm);
        const linkControl = link.getControl();

        const wrapper = $('<div>');
        wrapper.append(currentControl);
        linkControl.appendTo(wrapper);

        return wrapper;
    }

    private resolveValue(value: string | KnockoutObservable<string>): string {
        const unwrapped = ko.unwrap(value);

        if (this.detailViewItem.isPDEnumeration)
            return ResourceManager.getInstance().get(this.detailViewItem.possiblePDEnumerationValues[unwrapped]);
        else
            return unwrapped;
    }
}

ComponentManager.setFactory('InlineLabel', InlineLabelFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');